module.exports = __webpack_public_path__ + "media/images/content/pic_direction_s-69fca9ecbbbcaa1c2f1d2e7a7ad6b68f.svg";